import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function LifeInsurance({ classes, expanded, lifeInsurance, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('lifeInsurance')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('lifeInsurance') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Life Insurance</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        lifeInsurance.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                        {
                            lifeInsurance.isFlatAmount === 1 ?
                                `\nYou have $${ helpers.formatNumber(lifeInsurance.flatAmount) } of coverage.`
                                : `\nYou have ${ lifeInsurance.timesEarnings }x your annual salary of coverage.`
                        }
                    </Text>

                    {/* Todo: These maximums are conditional based on values, to prevent 0s being displayed */}
                    <Text small margin="5px 0px 0px 0px">
                        { lifeInsurance.maxEvidence > 0 ? `$${ helpers.formatNumber(lifeInsurance.maxEvidence) } Maximum with evidence of insurability.` : null }
                    </Text>

                    <Text small margin="5px 0px 0px 0px">
                        { lifeInsurance.maxNoEvidence > 0 ? `$${ helpers.formatNumber(lifeInsurance.maxNoEvidence) } Maximum with non-evidence of insurability.` : null }
                    </Text>

                    <Text small margin="5px 0px 0px 0px">
                        { lifeInsurance.minVolume > 0 ? `$${ helpers.formatNumber(lifeInsurance.minVolume) } Minimum.` : null }
                    </Text>

                    {
                        isStudent ?
                            <Text small margin="5px 0px 0px 0px">
                                { `Coverage reduces by ${ lifeInsurance.reducesBy }% at age ${ lifeInsurance.reducesAtAge }, provided the member is still actively studying.`}
                            </Text>
                            :
                            <Text small margin="5px 0px 0px 0px">
                                { `Coverage reduces by ${ lifeInsurance.reducesBy }% at age ${ lifeInsurance.reducesAtAge }, provided the member is still actively working.`}
                            </Text>
                    }

                    { 
                        Boolean(lifeInsurance.includeSecondReduction) && 
                            <Text small margin="5px 0px 0px 0px">
                                {
                                    `Coverage further reduces by ${ lifeInsurance.furtherReducesBy }% at age ${ lifeInsurance.furtherReductionAge }.`
                                }
                            </Text>
                    }

                    { 
                        Boolean(lifeInsurance.earlyPaymentPrivilege) && 
                            <Text small margin="5px 0px 0px 0px">
                                { 
                                    `${lifeInsurance.earlyPaymentPrivilegeType}.`
                                }
                            </Text>
                    }

                    {
                        isStudent ?
                            <Text small margin="5px 0px 10px 0px">
                                { `Terminates at age ${ lifeInsurance.terminationAge } or date of participants study if earlier.` }
                            </Text>
                            :
                            <Text small margin="5px 0px 10px 0px">
                                { `Terminates at age ${ lifeInsurance.terminationAge } or date of participants retirement if earlier.` }
                            </Text>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}